module.exports = __webpack_public_path__ + "img/initial_light.ab4afbdc.svg";